import React from 'react';
import Spinner from './spinner';

class CenteredSpinner extends React.Component {

  render() {
    return <div className="row justify-content-center" style={{width: '100%'}}>
      <Spinner/>
    </div>;
  }

}

export default CenteredSpinner;
